var map = {
	"./11_months.jpg": 361179,
	"./1yr_March_13.jpg": 459960,
	"./Bob,_Dick,_Marion_&_Bill.jpg": 156082,
	"./Bob,_Winfred,_Dick_&_Bill.jpg": 465659,
	"./Calvin,_John,_Grandma,_Will,_Gordon,_Dad_&_Margaret_Lake_Seattle_WA_1966.jpg": 888018,
	"./Calvin_&_Alice_Lake's_1966_01.jpg": 938549,
	"./Calvin_&_Alice_Lake's_1966_02.jpg": 271210,
	"./Calvin_&_Alice_Lake's_1966_03.jpg": 410215,
	"./Car.jpg": 196053,
	"./Cars.jpg": 868846,
	"./Charles_Clay_Lake_12-9-33.jpg": 674498,
	"./Charles_Clay_Lake_6yo_Washington_DC.jpg": 62009,
	"./Dad,_Dick_Mullett_&_Margaret_Fresno_Dec_1945.jpg": 355166,
	"./Dad,_Grandma,_Grandpa_&_Margaret_Fresno_01.jpg": 438802,
	"./Dad,_Grandma,_Grandpa_&_Margaret_Fresno_02.jpg": 948701,
	"./Dad,_Grandma_&_Duke_Richmond_VA.jpg": 310921,
	"./Dad,_Grandma_&_Grandpa_Lake,_David_&_Ed.jpg": 622058,
	"./Dad,_Grandma_&_Margaret_01.jpg": 448636,
	"./Dad,_Grandma_Lake_&_someone.jpg": 570491,
	"./Dad,_Great_Aunt_Marion_Lake_&_Margaret_Alameda_CA_1942.jpg": 765137,
	"./Dad,_Margaret,_Grandma_Lake_&_Duke_Richmond,_VA.jpg": 229425,
	"./Dad,_Margaret,_Grandma_Lake_&_someone.jpg": 481321,
	"./Dad,_Margaret_&_Grandma_Lake_with_Margaret,_Mike,_Gerry_&_Peter_Sroufe_Cannon_Beach_OR.jpg": 721917,
	"./Dad,_Margaret_&_friend.jpg": 290862,
	"./Dad,_Margaret_&_someone_1944.jpg": 686115,
	"./Dad_&_Dick_Mullett_Yosemite_Dec_1945.jpg": 564758,
	"./Dad_&_Duke_Richmond_VA_01.jpg": 677652,
	"./Dad_&_Duke_Richmond_VA_02.jpg": 107363,
	"./Dad_&_Friend_01.jpg": 960060,
	"./Dad_&_Friend_1936_02.jpg": 132711,
	"./Dad_&_Grandma.jpg": 945750,
	"./Dad_&_Grandma_Lake.jpg": 324586,
	"./Dad_&_Grandpa_1938.jpg": 156917,
	"./Dad_&_Great_Aunt_Marion_Lake_1936.jpg": 975637,
	"./Dad_&_Great_Grandma_Drescher_1936.jpg": 74629,
	"./Dad_&_Margaret_01.jpg": 561387,
	"./Dad_&_Margaret_02.jpg": 993692,
	"./Dad_&_Margaret_03.jpg": 591065,
	"./Dad_&_Margaret_04.jpg": 378474,
	"./Dad_&_Margaret_05.jpg": 1127,
	"./Dad_&_Margaret_06.jpg": 738552,
	"./Dad_&_Margaret_07.jpg": 529461,
	"./Dad_&_Margaret_08.jpg": 540230,
	"./Dad_&_Margaret_09.jpg": 921283,
	"./Dad_&_Margaret_10.jpg": 532421,
	"./Dad_&_Margaret_11.jpg": 888456,
	"./Dad_&_Margaret_13.jpg": 828218,
	"./Dad_&_Margaret_14.jpg": 264681,
	"./Dad_&_Margaret_15.jpg": 593068,
	"./Dad_&_Margaret_Alameda_CA_01.jpg": 528248,
	"./Dad_&_Margaret_Alameda_CA_02.jpg": 767124,
	"./Dad_&_Margaret_Alameda_CA_03.jpg": 48938,
	"./Dad_&_Smokie_Richmond_VA.jpg": 389005,
	"./Dad_&_dog_Alamo_CA.jpg": 853902,
	"./Dad_&_kittens_Richmond_VA.jpg": 497707,
	"./Dad_&_someone.jpg": 758446,
	"./Dad_(center)_with_friends_1937.jpg": 386629,
	"./Dad_1937_01.jpg": 128523,
	"./Dad_1937_02.jpg": 836540,
	"./Dad_1940.jpg": 684459,
	"./Dad_90.jpg": 370658,
	"./Dad_91.jpg": 283327,
	"./Dad_92.jpg": 898992,
	"./Dad_93.jpg": 999917,
	"./Dad_94.jpg": 718470,
	"./Dad_95.jpg": 40643,
	"./Dad_96.jpg": 662516,
	"./Dad_97.jpg": 359889,
	"./Dad_Alameda_CA_01.jpg": 608849,
	"./Dad_Alameda_CA_02.jpg": 451078,
	"./Dad_Alameda_CA_03.jpg": 289603,
	"./Dad_Army_Fort_Wood_1954.jpg": 612634,
	"./Dad_Army_uniform.jpg": 80271,
	"./Dad_Houston_TX_01.jpg": 276564,
	"./Dad_Houston_TX_02.jpg": 222627,
	"./Dad_Houston_TX_03.jpg": 332518,
	"./Dad_Houston_TX_04.jpg": 48717,
	"./Dad_Margaret_&_Grandma_Lake_Sequoia_National_Park.jpg": 686484,
	"./Dad_Newbury_England_July_1956.jpg": 957562,
	"./Dad_Portland_OR.jpg": 827143,
	"./Dad_Yosemite_Dec_1945.jpg": 908627,
	"./Dad_baby.jpg": 716309,
	"./Dad_baby_Berekley.jpg": 226785,
	"./Dad_goofing_off_with_Grandpa_&_Grandma_in_background.jpg": 914964,
	"./Dad_sitting_01.jpg": 500451,
	"./Dad_sitting_02.jpg": 554388,
	"./Dad_with_friend_01.jpg": 102890,
	"./Dad_with_friend_1937_01.jpg": 879753,
	"./Dad_with_friend_1937_02.jpg": 353022,
	"./Dad_with_friend_1937_03.jpg": 284507,
	"./Dad_young.jpg": 630137,
	"./David,_Grandpa_Lake,_Margaret_&_Grandma_Betanzos.jpg": 703474,
	"./David_&_Todd_Christmas_1976.jpg": 237355,
	"./David_01.jpg": 634391,
	"./David_02.jpg": 800168,
	"./Dick_Mullett,_Grandpa_Lake_&_Dad_Fresno_Dec_1945.jpg": 874774,
	"./Dick_Mullett,_Great_Aunt_Marion_Lake,_Margaret_&_Dad_Fresno_Dec_1945.jpg": 305720,
	"./Dick_Mullett_Fresno_Dec_1945.jpg": 886779,
	"./Dick_Mullett_Yosemite_Dec_1945_01.jpg": 82031,
	"./Dick_Mullett_Yosemite_Dec_1945_02.jpg": 968416,
	"./Dog_01.jpg": 639163,
	"./Dog_02.jpg": 296364,
	"./Dorothy,_Theodore_Sr_&_Margaret_Lake.jpg": 733140,
	"./Duke_Richmond,_VA.jpg": 901131,
	"./Ed,_David,_Todd_&_Margaret_Betanzos_July_1982_Fairwind_Caribbean_Cruise.jpg": 151196,
	"./Ed,_David_&_Todd_Christmas_1976.jpg": 896355,
	"./Ed,_Margaret,_Grandma_&_Grandpa_Lake,_Janet,_Kevin_&_Margaret_Sroufe_Grandparents_50th_Aniversary.jpg": 381864,
	"./Ella_Polk_Henry_mother_of_Margaret_H_Drescher_Grandmother_of_Dorothy_Lake.jpg": 402705,
	"./Family_picture_Fresno,_CA_01.jpg": 592529,
	"./Family_picture_Fresno,_CA_02.jpg": 434758,
	"./Family_picture_Fresno,_CA_03.jpg": 273283,
	"./Family_picture_Fresno,_CA_04.jpg": 131632,
	"./Family_picture_Fresno,_CA_05.jpg": 232557,
	"./Gerald_Sroufe_7_1-2yrs.jpg": 80652,
	"./Gerry_&_Peter_Sroufe_Cannon_Beach,_OR.jpg": 42787,
	"./Gerry_&_Peter_Sroufe_at_the_beach.jpg": 364163,
	"./Grandma,_Margaret_&_Dad_Richmond_VA.jpg": 289177,
	"./Grandma_Lake,_her_mom_&_sister_01.jpg": 846865,
	"./Grandma_Lake,_her_mom_&_sister_02.jpg": 689094,
	"./Grandma_Lake,_her_mom_&_sister_03.jpg": 527619,
	"./Grandma_Lake,_her_mom_&_sister_04.jpg": 385968,
	"./Grandma_Lake._Mrs_Murdoch_&_sister_Margaret.jpg": 732945,
	"./Grandma_Lake_&_Margaret_01.jpg": 795246,
	"./Grandma_Lake_&_Margaret_02.jpg": 75513,
	"./Grandma_Lake_&_Margaret_03.jpg": 604988,
	"./Grandma_Lake_&_Margaret_04.jpg": 206535,
	"./Grandma_Lake_&_baby.jpg": 195571,
	"./Grandma_Lake_&_friend_01.jpg": 393937,
	"./Grandma_Lake_&_friend_02.jpg": 752518,
	"./Grandma_Lake_&_friends.jpg": 342576,
	"./Grandma_Lake_&_friends_1935_01.jpg": 690285,
	"./Grandma_Lake_&_friends_1935_02.jpg": 61026,
	"./Grandma_Lake_(1yr_6mo)_with_sister_Margaret_(3yo).jpg": 233131,
	"./Grandma_Lake_(7_mos)_with_her_mom_&_sister_Margaret_(2_yrs_4_mos).jpg": 873255,
	"./Grandma_Lake_(left)_with_friends.jpg": 646129,
	"./Grandma_Lake_01.jpg": 613711,
	"./Grandma_Lake_02.jpg": 830720,
	"./Grandma_Lake_03.jpg": 556285,
	"./Grandma_Lake_04.jpg": 215766,
	"./Grandma_Lake_05.jpg": 371027,
	"./Grandma_Lake_in_parade_front_left.jpg": 365599,
	"./Grandma_Lake_with_her_mom_on_10th_Street.jpg": 707514,
	"./Grandma_Lake_with_sister_&_friend_on_donkey.jpg": 463710,
	"./Grandma_Lake_with_sister_&_friend_playing_7-30-14.jpg": 557334,
	"./Grandma_Lake_with_sister_Margaret_01.jpg": 746631,
	"./Grandma_Lake_with_sister_Margaret_02.jpg": 492824,
	"./Grandma_Lake_with_sister_Margaret_03.jpg": 100693,
	"./Grandma_Lake_with_sister_Margaret_04.jpg": 938222,
	"./Grandma_Lake_with_sister_Margaret_05.jpg": 132619,
	"./Grandma_Lake_with_sister_Margaret_06.jpg": 324284,
	"./Grandma_Lake_with_sister_Margaret_07.jpg": 345337,
	"./Grandma_Lake_with_sister_Margaret_21st_street_01.jpg": 981172,
	"./Grandma_Lake_with_sister_Margaret_21st_street_02.jpg": 875651,
	"./Grandma_Lake_with_sister_Margaret_7-30-1914.jpg": 831139,
	"./Grandma_Lake_with_sister_Margaret_Cannon_Beach_1916_or_1917.jpg": 644248,
	"./Grandma_Lake_with_sister_Margaret_Ocean_Park_CA_8-15-1913.jpg": 24075,
	"./Grandpa,_Dad_&_Friend_1936_01.jpg": 995160,
	"./Grandpa,_Dad_&_Grandma_01.jpg": 36530,
	"./Grandpa,_Dad_&_Grandma_1936.jpg": 728994,
	"./Grandpa_&_Grandma_Lake_01.jpg": 29430,
	"./Grandpa_&_Grandma_Lake_50th_Anniversary.jpg": 704315,
	"./Grandpa_Lake,_Dad,_Dick_Mullett_&_Margaret_Yosemite_Dec_1945.jpg": 318464,
	"./Grandpa_Lake_&_Dad_01.jpg": 77019,
	"./Grandpa_Lake_&_Dad_baby_Berekley.jpg": 601076,
	"./Grandpa_Lake_&_Dick_Mullett.jpg": 304189,
	"./Grandpa_Lake_&_Duke_Richmond,_VA.jpg": 63798,
	"./Grandpa_Lake_&_Family_(Marion,_Harry_Clay_Lake_&_Olive_Eugenia_Lake).jpg": 307145,
	"./Grandpa_Lake_&_Margaret_01.jpg": 387619,
	"./Grandpa_Lake_&_Margaret_02.jpg": 957908,
	"./Grandpa_Lake_&_Pam_1964.jpg": 108585,
	"./Grandpa_Lake_&_friend.jpg": 666800,
	"./Grandpa_Lake_&_friends.jpg": 206901,
	"./Grandpa_Lake_01.jpg": 443516,
	"./Grandpa_Lake_02.jpg": 251851,
	"./Grandpa_Lake_03.jpg": 57454,
	"./Grandpa_Lake_04.jpg": 219925,
	"./Grandpa_Lake_05.jpg": 612056,
	"./Grandpa_Lake_06.jpg": 865863,
	"./Grandpa_Lake_07.jpg": 371293,
	"./Grandpa_Lake_08.jpg": 481137,
	"./Grandpa_Lake_hiking_(on_far_left).jpg": 729716,
	"./Grandpa_Lake_skiing_with_friend.jpg": 599866,
	"./Grandpa_Lake_sleeping_on_porch.jpg": 248763,
	"./Great_Grandpa_Harry_Lake_&_Dad_1936.jpg": 838466,
	"./Great_Grandpa_Lake_&_Chris_1986_01.jpg": 479322,
	"./Great_Grandpa_Lake_&_Chris_1986_02.jpg": 324306,
	"./Harry_Clay_Lake_11-8-1908.jpg": 145674,
	"./House_01.jpg": 96429,
	"./House_02.jpg": 467170,
	"./House_03.jpg": 379839,
	"./House_04.jpg": 759028,
	"./House_05.jpg": 456401,
	"./House_06.jpg": 298630,
	"./House_Fresno,_CA.jpg": 787450,
	"./House_Richmond,_VA.jpg": 311196,
	"./Johnny_Christmas_1939.jpg": 790437,
	"./June_20_1945.jpg": 461304,
	"./Lori,_Pam,_Marcus,_Amanda,_Dad_&_Grandpa_Aug_1990.jpg": 467158,
	"./Lori_&_Grandpa_01.jpg": 91446,
	"./Margaret,_Dad,_Mike,_Gerry_&_Peter_Sroufe_Cannon_Beach,_OR.jpg": 72070,
	"./Margaret,_Dad_&_someone.jpg": 977948,
	"./Margaret,_Grandpa_Lake,_David_&_Ed.jpg": 352438,
	"./Margaret,_Grandpa_Lake,_Grandma_Betanzos_&_Ed_01.jpg": 601239,
	"./Margaret,_Tommy_Mason_&_Mike_Sroufe_with_Dad_in_background_at_Cannon_Beach_July_1946.jpg": 669955,
	"./Margaret_&_Dad_01.jpg": 825273,
	"./Margaret_&_Dad_Alameda,_CA_02.jpg": 688065,
	"./Margaret_&_Dad_Fresno,_CA_01.jpg": 639458,
	"./Margaret_&_Dad_Fresno,_CA_02.jpg": 752365,
	"./Margaret_&_Dick_Mullett_Yosemite_Dec_1945.jpg": 415604,
	"./Margaret_&_Mike_Sroufe_(4_wks).jpg": 723997,
	"./Margaret_&_baby_Jun_14_1971.jpg": 290505,
	"./Margaret_&_friend.jpg": 879758,
	"./Margaret_01.jpg": 597958,
	"./Margaret_02.jpg": 755729,
	"./Margaret_03.jpg": 177204,
	"./Margaret_04.jpg": 679167,
	"./Margaret_05.jpg": 859170,
	"./Margaret_06.jpg": 91309,
	"./Margaret_07.jpg": 964208,
	"./Margaret_08.jpg": 619115,
	"./Margaret_09.jpg": 992654,
	"./Margaret_10.jpg": 984612,
	"./Margaret_11.jpg": 662657,
	"./Margaret_12.jpg": 792310,
	"./Margaret_13.jpg": 678771,
	"./Margaret_Fresno,_CA_01.jpg": 257455,
	"./Margaret_Fresno,_CA_02.jpg": 143840,
	"./Margaret_Fresno,_CA_03.jpg": 594973,
	"./Margaret_Fresno,_CA_05.jpg": 226675,
	"./Margaret_Fresno,_CA_06.jpg": 532516,
	"./Margaret_Fresno,_CA_07.jpg": 210561,
	"./Margaret_Fresno,_CA_08.jpg": 843098,
	"./Margaret_Fresno,_CA_09.jpg": 406935,
	"./Margaret_Grandma_Lake_&_Dad_01.jpg": 666896,
	"./Margaret_Sroufe,_Ed,_Mom,_Janet,_Dad,_Grandpa,_Margaret,_David,_Tom,_Chris_&_Pam_Grandma_Lake's_Service.jpg": 510635,
	"./Margaret_Sroufe_&_Gerry.jpg": 994584,
	"./Margaret_Sroufe_&_Gerry_3mos.jpg": 852643,
	"./Margaret_Sroufe_&_her_kids_(Gerry_3mos).jpg": 623308,
	"./Margaret_in_sand_Mike_Sroufe_&_Dad_Canon_Beach,_OR_July_1946.jpg": 512496,
	"./Marguerite_Lake_Mullett_Kirkland.jpg": 942589,
	"./Marguerite_Lake_Mullett_Kirkland_4-22-1990.jpg": 475115,
	"./Marion_&_Margaret_Lake.jpg": 216742,
	"./Marion_Lake.jpg": 431791,
	"./Marion_Lake_&_Dick_Mullett_Fresno_Dec_1945.jpg": 994933,
	"./Marion_Lake_&_Dick_Mullett_Yosemite_Dec_1945.jpg": 163987,
	"./Michael_Sroufe_10yrs.jpg": 234445,
	"./Mike,_Gerry_&_Peter_Sroufe_Cannon_Beach,_OR.jpg": 221708,
	"./Mike,_Gerry_&_Peter_Sroufe_Cannon_Beach,_OR_Summer_1949.jpg": 500128,
	"./Mike,_Peter_&_Gerry_Sroufe_Christmas_Eve_1949.jpg": 754466,
	"./Mike,_Peter_&_Gerry_Sroufe_with_friend.jpg": 814968,
	"./Mike_&_Margaret_Sroufe.jpg": 359251,
	"./Mike_Sroufe_(18_mo).jpg": 578500,
	"./Mike_Sroufe_(4yo)_July_1946.jpg": 5814,
	"./Mike_Sroufe_(7_mo)_10-13-42.jpg": 127294,
	"./Mike_Sroufe_Cannon_Beach.jpg": 313572,
	"./Mrs_Cole's_&_Mullett_family_homes_Quitman_Miss.jpg": 306063,
	"./Mrs_Cole's_home_previously_Mullett_home_birthplace_of_Richard_Mullett.jpg": 884459,
	"./Mullett_&_Cole_family_homes_01.jpg": 327483,
	"./Mullett_home_Quitman_Miss.jpg": 248575,
	"./Mullett_home_Quitman_Miss_Birthplace_of_Robert_&_William.jpg": 619142,
	"./Pacific_Coast_Bisc_Co_June_1928_Harold_Conkling,_Harold_Pittenger,_J._Mac_Connell,_T.P._Lake_&_H.T._Tucker.jpg": 937210,
	"./Pam_&_Tom_01.jpg": 758505,
	"./Pam_&_Tom_trick_photo_01.jpg": 523522,
	"./Pam_&_Tom_trick_photo_02.jpg": 469453,
	"./Peter_Sroufe_Aug_1949.jpg": 114020,
	"./Peter_Sroufe_Christmas_Eve_1949.jpg": 147062,
	"./Robert,_Marguerite,_Richard_&_Stuart_Kirkland_5-1954.jpg": 218887,
	"./Robert,_Marguerite,_Stuart_&_William_5-1954.jpg": 547466,
	"./Robert,_Marguerite,_William_&_Richard_5-1954.jpg": 373716,
	"./Robert,_Marguerite_&_William_Mullett.jpg": 96024,
	"./Robert,_Richard,_Marguerite_&_William_5-1954.jpg": 336868,
	"./Rudolph,_Marion_&_Grandpa_Lake.jpg": 901897,
	"./Santa_on_camel.jpg": 146657,
	"./Scenery_01.jpg": 555672,
	"./Scenery_02.jpg": 835655,
	"./Scenery_03.jpg": 867914,
	"./Scenery_04.jpg": 704633,
	"./Scenery_05.jpg": 717756,
	"./Scenery_06.jpg": 102411,
	"./Scenery_07.jpg": 424366,
	"./Scenery_08.jpg": 523021,
	"./Scenery_09.jpg": 778128,
	"./Scenery_10.jpg": 226526,
	"./Scenery_11.jpg": 346683,
	"./Scenery_12.jpg": 3884,
	"./Scenery_13.jpg": 218025,
	"./Scenery_14.jpg": 112186,
	"./Scenery_15.jpg": 464119,
	"./Scenery_16.jpg": 841800,
	"./Scenery_17.jpg": 969413,
	"./Scenery_18.jpg": 66774,
	"./Scenery_19.jpg": 611539,
	"./Todd,_David_&_Grandma_Lake_1983.jpg": 971155,
	"./Todd,_Grandpa_Lake,_David_&_Ed.jpg": 891888,
	"./Todd_&_David_Christmas_1976.jpg": 454947,
	"./Todd_01.jpg": 724228,
	"./Todd_02.jpg": 824275,
	"./Tom_&_Todd_1983.jpg": 962774,
	"./Tom_Dhahran_Jr_High_Graduation.jpg": 269951,
	"./Tom_trick_photos_01.jpg": 202497,
	"./Unknown_01.jpg": 721531,
	"./Unknown_02.jpg": 344556,
	"./Unknown_03.jpg": 499817,
	"./Unknown_04.jpg": 63354,
	"./Unknown_05.jpg": 50871,
	"./Unknown_06.jpg": 123592,
	"./Unknown_07.jpg": 767557,
	"./Unknown_08.jpg": 407446,
	"./Unknown_09.jpg": 562707,
	"./Unknown_11.jpg": 379992,
	"./Unknown_12.jpg": 633799,
	"./Unknown_14.jpg": 232505,
	"./Unknown_15.jpg": 211452,
	"./Unknown_16.jpg": 19787,
	"./Unknown_House.jpg": 254832,
	"./William,_Richard_&_Robert_Mullett.jpg": 457488,
	"./William_Mullett_in_Mrs_Cole's_side_yard_01.jpg": 60636,
	"./William_Mullett_in_Mrs_Cole's_side_yard_02.jpg": 602155,
	"./Yosemite_Dec_1945.jpg": 24145
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 129072;